import { render, staticRenderFns } from "./empty-bucket.vue?vue&type=template&id=f0a9d2b4&scoped=true"
import script from "./empty-bucket.vue?vue&type=script&lang=js"
export * from "./empty-bucket.vue?vue&type=script&lang=js"
import style0 from "./empty-bucket.vue?vue&type=style&index=0&id=f0a9d2b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a9d2b4",
  null
  
)

export default component.exports